import React, { useState } from 'react'

import { Tabs } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import AuthFlow from 'Pods/LazyLoaded/AuthModal/AuthFlow'
import { MODE } from 'Pods/LazyLoaded/AuthModal/constants'
import I18n from 'Pods/Shared/I18n'

function UserTabs({
  activeTabId = '',
  locale = 'en',
}) {
  // Controlled so the AuthFlow footer switch link can change the active tab.
  const [activeId, setActiveId] = useState(activeTabId || 'login')

  const translate = (key) => I18n.t(key, { ns: 'rails', lng: locale })

  const loginTab = {
    title: translate('navigation.user.login'),
    id: 'login',
    expand: true,
    // Keyed by mode: both tabs render the same component type at the same
    // position, so without a key React reuses the instance and its internal
    // mode state would survive the tab switch.
    contents: (
      <AuthFlow key={MODE.LOGIN} mode={MODE.LOGIN} locale={locale} onSwitchMode={() => setActiveId('register')} />
    ),
  }
  const registerTab = {
    title: translate('navigation.user.register'),
    id: 'register',
    expand: true,
    contents: (
      <AuthFlow key={MODE.SIGNUP} mode={MODE.SIGNUP} locale={locale} onSwitchMode={() => setActiveId('login')} />
    ),
  }

  return (
    <Tabs
      className="auth-tabs"
      expand
      activeTabId={activeId}
      onClick={setActiveId}
      tabs={[
        loginTab,
        registerTab,
      ]}
    />
  )
}

UserTabs.propTypes = {
  activeTabId: string,
  locale: string,
}

export default UserTabs
